import { getURL } from '@domain/infrastructure'
import Toggles from '@domain/toggles/Toggles'
import CommonApiCaller from '@vibialighting/api-kit/apiCaller'

type servicesTypes = 'products' | 'v2' | '' | "cms" | 'masters'
type restMethod = 'GET' | 'POST' | 'PUT' | 'DELETE'

class ApiCaller extends CommonApiCaller {
    static async call(service: servicesTypes, method: restMethod, route: string, payload?: any, configs?: any, subdomain = 'api.', headers?: any) {
        if (Toggles.isEnabled("useNewApiCaller")) {
            return super.call(service, method, route, payload, configs, subdomain, headers)
        } else {
            const path = service ? `${service}/${route}` : route
            const url = getURL(path, subdomain)
            switch (method) {
                case 'GET':
                    const getResponse = await fetch(url, {
                        method,
                        ...configs,
                        credentials: 'include'
                    })
                    if (ApiCaller.isStatus2XX(getResponse)) {
                        return getResponse.json()
                    }

                    throw ({
                        ErrorCode: getResponse.status,
                        ErrorDescription: getResponse.statusText
                    })
                case 'POST':
                case 'PUT':
                    const postResponse = await fetch(url, {
                        method,
                        headers: headers ?? {
                            'Content-Type': 'application/json',
                        },
                        body: payload,
                        credentials: 'include',
                        ...configs
                    })

                    if (ApiCaller.isStatus2XX(postResponse)) {
                        if (postResponse.status === 204) return ''
                        return postResponse.json()
                    }

                    throw ({
                        ErrorCode: postResponse.status,
                        ErrorDescription: postResponse.statusText
                    })
                case 'DELETE':
                    const getResponse1 = await fetch(url, {
                        method,
                        credentials: 'include',
                        ...configs
                    })
                    if (ApiCaller.isStatus2XX(getResponse1)) {
                        return
                    }

                    throw ({
                        ErrorCode: getResponse1.status,
                        ErrorDescription: getResponse1.statusText
                    })
                default:
                    throw `Invalid method "${method}". Valid methods 'GET', 'PUT' or 'POST.`
            }
        }
    }

    static async plainCall(fullPath: string, method: restMethod) {
        if (Toggles.isEnabled("useNewApiCaller")) {
            return super.plainCall(fullPath, method)
        } else {
            switch (method) {
                case 'GET':
                    const getResponse = await fetch(fullPath)
                    if (ApiCaller.isStatus2XX(getResponse)) {
                        return getResponse
                    }

                    throw ({
                        ErrorCode: getResponse.status,
                        ErrorDescription: getResponse.statusText
                    })
                default:
                    throw `Invalid method "${method}". Valid methods 'GET', 'PUT' or 'POST.`
            }
        }
    }
}

export default ApiCaller